export default {"src":"/_next/static/media/neo.65a8d1af.gif","height":214,"width":343,"blurWidth":0,"blurHeight":0};